import { Fields } from './types';

export const sortFields = [Fields.STATUS, Fields.DOCUMENT_TYPE, Fields.DATE, Fields.SENDER];

export const SORT_DEFAULT_VALUE_INDEX = 4
